/**
 *
 * Asynchronously loads the component for ApiManagement
 *
 */

import loadable from "util/loadable";

export default loadable(() => import("./index"));
